













import { Component, Vue } from "vue-property-decorator";
import { Tab, Tabs } from 'vant';
import { getQueryParam } from "@/utils/index";
import DiscussTopicList from "@/components/DiscussTopicList.vue";

Vue.use(Tab);
Vue.use(Tabs);

@Component({
    components: {
        "v-discuss-topic-list": DiscussTopicList
    }
})
export default class ForumList extends Vue {
    cityId: number = 0;
    activeId: number = 0;

    sticky: boolean = true;

    tabList: any = [
        {
            id: 1,
            name: "贷款业务"
        },
        {
            id: 2,
            name: "提取业务"
        },
        {
            id: 3,
            name: "缴存业务"
        },
        {
            id: 4,
            name: "其他业务"
        }
    ];
    
    mounted() {
        let cityId: number = parseInt(this.$route.params.cityId);
        this.cityId = cityId;
    }

    onCreateTopic() {
        this.$router.push({path: "/fund/forum/createtopic/" + this.cityId + "/" + this.activeId});
    }
}
